import { render, staticRenderFns } from "./highTaskExamineByLaws.vue?vue&type=template&id=6c2a3310&scoped=true&"
import script from "./highTaskExamineByLaws.vue?vue&type=script&lang=js&"
export * from "./highTaskExamineByLaws.vue?vue&type=script&lang=js&"
import style0 from "./highTaskExamineByLaws.vue?vue&type=style&index=0&id=6c2a3310&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a3310",
  null
  
)

export default component.exports